import { useContext } from "react";

import { CommentFilterContext } from "./Context";

export function useCommentFilterContext() {
  return useContext(CommentFilterContext);
}

export default useCommentFilterContext;
